module.exports = __webpack_public_path__ + "img/ry_11.72e5e698.png";